import { Card, CardContent, useTheme, Typography, CardHeader } from '@mui/material';
import NotificationsNews from './NotificationsNews';
import { useTranslation } from 'react-i18next';

const Notifications = (props: { storeNumber: string | undefined }) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: theme.palette.common.white,
        borderRadius: '12px',
        border: `1px solid ${theme.palette.custom.gray[200]}`,
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        scrollbarGutter: 'stable',
      }}
    >
      <CardHeader
        sx={{
          p: '24px',
          pb: '16px',
          textAlign: 'left',
        }}
        title={
          <Typography
            variant="textLG"
            sx={{
              fontWeight: 700,
              color: theme.palette.custom.gray[900],
            }}
          >
            {t('notificationTitle')}
          </Typography>
        }
      />

      <CardContent
        sx={{
          px: '24px',
          py: '0px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <NotificationsNews storeNumber={props?.storeNumber} />
      </CardContent>
    </Card>
  );
};

export default Notifications;